let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Kouf")).then(() => parcelRequire('ti4SO'));